import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GroupsPageComponent } from './groups-page/groups-page.component';
import { GroupPageComponent } from './group-page/group-page.component';
import { SharedModule } from '../../shared/shared.module';
import { GroupsRoutingModule } from './groups-routing.module';
import { DisallowGroupDeleteModalComponent } from './disallow-group-delete-modal/disallow-group-delete-modal.component';
import { ModalModule } from '../../core/modal/modal.module';
import { EmptyListComponent } from '../../shared/empty-list/empty-list.component';

@NgModule({
  imports: [
    SharedModule,
    GroupsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule,
    EmptyListComponent,
  ],
  exports: [],
  declarations: [
    GroupsPageComponent,
    GroupPageComponent,
    DisallowGroupDeleteModalComponent,
  ],
  providers: [],
})
export class GroupsModule {
}
